(function () {
  'use strict';

  /* ================================================================
     NewPharma - el carrito se acomoda solo al mejor tramo

     Dos trabajos distintos:

     1. OPTIMIZAR (en cualquier cambio del carrito). Nunca cambia cuantas
        unidades lleva el cliente: solo las reparte en los tramos que
        salen mas baratos. Asi, quien aprieta "Agregar al carrito" tres
        veces termina con un Pack de 3 sin hacer nada.

     2. LA ESCALERA (botones + y - del cajon). Ahi + y - mueven UNA
        UNIDAD, no una linea. Sin esto, al pasar a "Pack de 2 x 1" el
        boton - dejaba la linea en cero y borraba el producto: el cliente
        que queria bajar de 2 a 1 se quedaba sin nada.

     POR QUE SE INTERCEPTA EL CLIC Y NO SE MIRA EL RESULTADO. Despues del
     hecho no se puede distinguir "+1 linea" de "+1 unidad": si el tema
     lleva "Pack de 2" de 1 a 2, el total salta de 2 a 4 unidades y no hay
     forma de saber que el cliente queria 3.

     EL FETCH ORIGINAL SE GUARDA ANTES DE PARCHARLO. Las llamadas propias
     van por ahi y no vuelven a entrar al interceptor. Es la misma trampa
     que ya estaba documentada para free-gift.js.

     Y LA BANDERA ES `pendiente`, NO `ocupado`. Si llega una accion del
     cliente mientras hay un chequeo corriendo, se anota y se vuelve a
     mirar al terminar, en vez de descartarla. Esa confusion fue el viejo
     "a veces no aparece el regalo".
     ================================================================ */

  var fetchOriginal = window.fetch.bind(window);
  var trabajando = false;
  var pendiente = false;
  var cacheTramos = {};
  var aviso = null;

  /* ------------------------------------------------ utilidades ---- */

  // "Pack de 2 unidades" -> 2 ; "1 unidad" -> 1. Primer token numerico,
  // igual que en la ficha y en la linea del carrito.
  function unidadesDe(titulo) {
    var tk = String(titulo || '').split(/\s+/);
    for (var i = 0; i < tk.length; i++) {
      var n = parseInt(tk[i], 10);
      if (n > 0) return n;
    }
    return 0;
  }

  function esTramo(item) {
    var o = item.options_with_values;
    return !!(o && o.length && o[0].name === 'Cantidad');
  }

  function dinero(centavos) {
    return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
  }

  function postJSON(url, cuerpo) {
    return fetchOriginal(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      if (!r.ok) throw new Error(url);
      return r.json();
    });
  }

  // Tramos DISPONIBLES del producto, indexados por unidades.
  function tramosDe(handle) {
    if (cacheTramos[handle]) return Promise.resolve(cacheTramos[handle]);
    return fetchOriginal('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var t = {};
        (d.variants || []).forEach(function (v) {
          var u = unidadesDe(v.title);
          if (u > 0 && v.available) t[u] = v;
        });
        cacheTramos[handle] = t;
        return t;
      });
  }

  /* ------------------------------------------------ el reparto ---- */

  // Codicioso: la mayor cantidad de tramos grandes y el resto abajo. Con
  // 15% y 20% eso da siempre el minimo. Para un resto de 1 unidad, 3+1 y
  // 2+2 cuestan lo mismo y se elige 3+1 por dejar menos lineas.
  function componer(total, tramos) {
    var escalones = Object.keys(tramos).map(Number).sort(function (a, b) { return b - a; });
    var plan = {};
    var resto = total;
    escalones.forEach(function (u) {
      if (u === 1) return;
      var n = Math.floor(resto / u);
      if (n > 0) { plan[u] = n; resto -= n * u; }
    });
    if (resto > 0) {
      if (!tramos[1]) return null;
      plan[1] = (plan[1] || 0) + resto;
    }
    return plan;
  }

  function planDeLineas(lineas) {
    var p = {};
    lineas.forEach(function (l) {
      var u = unidadesDe(l.variant_title);
      if (u > 0) p[u] = (p[u] || 0) + l.quantity;
    });
    return p;
  }

  function mismoPlan(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) {
      if (a[ka[i]] !== b[ka[i]]) return false;
    }
    return true;
  }

  // Si alguna variante del carrito no esta entre los tramos disponibles
  // (se agoto, por ejemplo), no se toca ese producto: rearmarlo perderia
  // unidades que despues no se pueden volver a agregar.
  function todasConocidas(lineas, tramos) {
    var ids = {};
    Object.keys(tramos).forEach(function (k) { ids[tramos[k].id] = true; });
    return lineas.every(function (l) { return ids[l.variant_id]; });
  }

  function updatesDe(lineas, tramos, plan) {
    var u = {};
    Object.keys(tramos).forEach(function (k) { u[tramos[k].id] = 0; });
    lineas.forEach(function (l) { u[l.variant_id] = 0; });
    Object.keys(plan).forEach(function (k) {
      if (tramos[k]) u[tramos[k].id] = plan[k];
    });
    return u;
  }

  function ahorroDe(plan, tramos, total) {
    if (!tramos[1]) return 0;
    var bruto = tramos[1].price * total;
    var neto = 0;
    Object.keys(plan).forEach(function (k) { neto += tramos[k].price * plan[k]; });
    return bruto - neto;
  }

  function nombreDelPlan(plan, tramos) {
    var ks = Object.keys(plan).map(Number).sort(function (a, b) { return b - a; });
    return ks.map(function (u) {
      return (plan[u] > 1 ? plan[u] + ' x ' : '') + tramos[u].title;
    }).join(' + ');
  }

  /* ------------------------------------------------ agrupar -------- */

  function porProducto(carrito) {
    var g = {};
    (carrito.items || []).forEach(function (it) {
      if (!esTramo(it)) return;
      if (!g[it.product_id]) g[it.product_id] = { handle: it.handle, lineas: [] };
      g[it.product_id].lineas.push(it);
    });
    return g;
  }

  // Retrato del carrito para detectar que cambio mientras calculabamos.
  function firma(carrito) {
    return (carrito.items || []).map(function (i) {
      return i.variant_id + ':' + i.quantity;
    }).join('|');
  }

  function totalUnidades(lineas) {
    return lineas.reduce(function (s, l) {
      return s + unidadesDe(l.variant_title) * l.quantity;
    }, 0);
  }

  /* ------------------------------------------------ 1. optimizar --- */

  function revisar() {
    if (trabajando) { pendiente = true; return; }
    trabajando = true;

    fetchOriginal('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var antes = firma(c);
        var g = porProducto(c);
        var ids = Object.keys(g);
        if (!ids.length) return null;

        return Promise.all(ids.map(function (pid) {
          var grupo = g[pid];
          return tramosDe(grupo.handle).then(function (tramos) {
            if (!todasConocidas(grupo.lineas, tramos)) return null;
            var total = totalUnidades(grupo.lineas);
            if (total < 1) return null;
            var plan = componer(total, tramos);
            if (!plan) return null;
            if (mismoPlan(plan, planDeLineas(grupo.lineas))) return null;
            var ahorro = ahorroDe(plan, tramos, total);
            if (ahorro > 0) {
              aviso = 'Te pasamos a ' + nombreDelPlan(plan, tramos) +
                      ': ahorras ' + dinero(ahorro);
            }
            return updatesDe(grupo.lineas, tramos, plan);
          });
        })).then(function (lista) {
          var todo = {};
          var hay = false;
          lista.forEach(function (u) {
            if (!u) return;
            hay = true;
            Object.keys(u).forEach(function (k) { todo[k] = u[k]; });
          });
          if (!hay) return null;
          // El carrito pudo cambiar mientras pediamos las fichas de cada
          // producto. Escribir el plan viejo resucitaria lineas que el
          // cliente acaba de quitar.
          return fetchOriginal('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (ahora) {
              if (firma(ahora) !== antes) {
                aviso = null;
                pendiente = true;
                return null;
              }
              return postJSON('/cart/update.js', { updates: todo }).then(function () { return true; });
            });
        });
      })
      .then(function (cambio) { if (cambio) repintar(); })
      .catch(function () { aviso = null; })
      .then(function () {
        trabajando = false;
        if (pendiente) { pendiente = false; revisar(); }
      });
  }

  /* ------------------------------------------------ 2. escalera ---- */

  function ajustar(indice, delta) {
    ajustarLinea(function (items) { return items[indice - 1]; }, delta);
  }

  // Ahora que el aviso sobrevive a los redibujados, hay que sacarlo en
  // cuanto arranca otro cambio: si no, anunciaria un ahorro viejo.

  function ajustarLinea(encontrar, delta) {
    if (trabajando) return;
    trabajando = true;
    limpiarAviso();

    fetchOriginal('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var it = encontrar(c.items || []);
        if (!it || !esTramo(it)) return null;

        var lineas = c.items.filter(function (x) {
          return x.product_id === it.product_id && esTramo(x);
        });

        return tramosDe(it.handle).then(function (tramos) {
          if (!todasConocidas(lineas, tramos)) return null;

          var nuevo = totalUnidades(lineas) + delta;
          var updates = {};
          Object.keys(tramos).forEach(function (k) { updates[tramos[k].id] = 0; });
          lineas.forEach(function (l) { updates[l.variant_id] = 0; });

          if (nuevo > 0) {
            var plan = componer(nuevo, tramos);
            if (!plan) return null;
            Object.keys(plan).forEach(function (k) {
              if (tramos[k]) updates[tramos[k].id] = plan[k];
            });
            var ahorro = ahorroDe(plan, tramos, nuevo);
            if (ahorro > 0 && !mismoPlan(plan, planDeLineas(lineas))) {
              aviso = 'Te pasamos a ' + nombreDelPlan(plan, tramos) +
                      ': ahorras ' + dinero(ahorro);
            }
          }

          return postJSON('/cart/update.js', { updates: updates }).then(function () { return true; });
        });
      })
      .then(function (ok) { if (ok) repintar(); })
      .catch(function () { aviso = null; })
      .then(function () { trabajando = false; });
  }

  // Captura a proposito: hay que ganarle al componente <cart-quantity>
  // del tema ANTES de que mande su propio cambio de cantidad.
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-cart-quantity-button]') : null;
    if (!btn) return;

    // La linea es de tramos solo si trae la etiqueta de unidades que
    // emite cart-drawer.liquid. Es el unico dato sincronico que hay.
    var card = btn.closest('.cart-drawer__product_card');
    if (!card || !card.querySelector('.np-cart-unidades')) return;

    var cq = btn.closest('cart-quantity');
    var indice = cq ? parseInt(cq.getAttribute('data-item-index'), 10) : 0;
    if (!indice) return;

    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

    ajustar(indice, btn.getAttribute('name') === 'plus' ? 1 : -1);
  }, true);

  /* ------------------------------------- la escalera en /cart ------ */

  /* En /cart el + y el - del tema solo escriben en el input: el carrito no
     cambia hasta apretar "Actualizar carrito". Por eso se veia cantidad 3
     con el total de 1 unidad. Aca se les da el mismo comportamiento que en
     el cajon: mueven una unidad y el carrito se rearma al mejor tramo.

     Que variantes son de tramo se precarga al abrir la pagina, porque la
     decision de cancelar el clic tiene que tomarse en el acto. */
  var variantesTramo = {};

  function cargarVariantesTramo() {
    return fetchOriginal('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        variantesTramo = {};
        (c.items || []).forEach(function (it) {
          if (esTramo(it)) variantesTramo[String(it.variant_id)] = true;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('.js-qty__adjust') : null;
    if (!b) return;

    var caja = b.closest('.js-qty');
    var inp = caja ? caja.querySelector('.js-qty__num') : null;
    var m = inp && inp.id ? /updates_(\d+)/.exec(inp.id) : null;
    if (!m || !variantesTramo[m[1]]) return;

    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

    var vid = m[1];
    ajustarLinea(function (items) {
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].variant_id) === vid) return items[i];
      }
      return null;
    }, b.classList.contains('js-qty__adjust--plus') ? 1 : -1);
  }, true);

  if (location.pathname.indexOf('/cart') === 0) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cargarVariantesTramo);
    } else {
      cargarVariantesTramo();
    }
  }

  /* ------------------------------------------------ repintado ------ */

  function repintar() {
    var enPaginaCart = location.pathname.indexOf('/cart') === 0;
    if (!enPaginaCart && window.eventBus && typeof window.eventBus.emit === 'function') {
      window.eventBus.emit('render:cart:drawer');
      avisarTrasRedibujado();
    } else {
      // La pagina /cart no se redibuja sola: su tabla quedaria vieja.
      window.location.reload();
    }
  }

  // El tema REEMPLAZA las zonas [data-cart-dynamic-content] al redibujar,
  // asi que se observa un ancestro estable y se inserta recien cuando el
  // redibujado ya paso. Con un setTimeout fijo el aviso se insertaba en el
  // DOM viejo y desaparecia sin dejar rastro.
  function avisarTrasRedibujado() {
    if (!aviso) return;
    var raiz = document.querySelector('.global-drawer__content') ||
               document.querySelector('.global-drawer');
    if (!raiz || typeof MutationObserver !== 'function') {
      setTimeout(mostrarAviso, 400);
      return;
    }
    var hecho = false;
    var quieto = null;

    function rematar() {
      if (hecho) return;
      hecho = true;
      clearTimeout(quieto);
      obs.disconnect();
      mostrarAviso();
    }

    // El redibujado toca el DOM varias veces seguidas. Insertar en la
    // PRIMERA mutacion metia el aviso a mitad del reemplazo y el resto del
    // render se lo llevaba puesto. Se espera a que quede quieto 300 ms.
    var obs = new MutationObserver(function () {
      clearTimeout(quieto);
      quieto = setTimeout(rematar, 300);
    });
    obs.observe(raiz, { childList: true, subtree: true });

    // Si el redibujado nunca llega -o nunca para- se muestra igual.
    setTimeout(rematar, 2500);
  }

  function limpiarAviso() {
    var viejos = document.querySelectorAll('.np-aviso-tramo');
    for (var i = 0; i < viejos.length; i++) {
      if (viejos[i].parentNode) viejos[i].parentNode.removeChild(viejos[i]);
    }
  }

  function mostrarAviso() {
    if (!aviso) return;
    var cuerpo = document.querySelector('[data-cart-dynamic-content="cart-body"]');
    var padre = cuerpo ? cuerpo.parentNode : null;
    if (!padre) { aviso = null; return; }

    // VA AFUERA de [data-cart-dynamic-content]: el tema reemplaza esas
    // zonas enteras al redibujar y se llevaba el aviso puesto. Como
    // hermano, colgado del contenedor del cajon, sobrevive.
    limpiarAviso();

    var n = document.createElement('div');
    n.className = 'np-aviso-tramo';
    n.textContent = aviso;
    padre.insertBefore(n, cuerpo);
    aviso = null;

    // NO se esconde solo: el ahorro es informacion que ayuda a decidir.
    // Se va cuando el cliente vuelve a mover el carrito, porque ahi el tema
    // redibuja el cajon y el aviso ya no seria cierto.
    requestAnimationFrame(function () { n.classList.add('is-visible'); });
  }

  /* ------------------------------------------------ enganche ------- */

  // Ultimo /cart/add.js mandado, para colapsar los duplicados que genera
  // el QuickAdd repetido del tema (ver comentario de cabecera).
  var ultimoAdd = { clave: '', hora: 0, promesa: null };
  var VENTANA_DUPLICADO = 700;

  window.fetch = function (entrada, opciones) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var esCarrito = /\/cart\/(add|change|update|clear)/.test(url);

    if (/\/cart\/add/.test(url) && opciones && typeof opciones.body === 'string') {
      var clave = url + '|' + opciones.body;
      var ahora = Date.now();
      if (ultimoAdd.promesa && ultimoAdd.clave === clave &&
          (ahora - ultimoAdd.hora) < VENTANA_DUPLICADO) {
        // Misma peticion, mismo instante: es el listener de mas.
        return ultimoAdd.promesa;
      }
      limpiarAviso();
      var pa = fetchOriginal(entrada, opciones);
      ultimoAdd = { clave: clave, hora: ahora, promesa: pa };
      pa.then(function () { setTimeout(revisar, 60); }, function () {});
      return pa;
    }

    var p = fetchOriginal(entrada, opciones);
    if (esCarrito) {
      p.then(function () { setTimeout(revisar, 60); }, function () {});
    }
    return p;
  };
})();
